import Slider from "react-slick";
import { useSelector } from "react-redux";
import { Link } from "react-router-dom";
import {
  NextArrow,
  PrevArrow,
} from "../../components/SlickButtons/SlickButtons";
import "./UserFavorites.css";
import useDevice from "../../hooks/useDevice";
import CardSkeleton from "../../components/Skeleton/CardSkeleton";
import { useGetUserFavorites } from "../../hooks/useGetUserFavorites";

function UserFavorites() {
  const token = useSelector((state) => state.auth.token);
  const { isMobile, isTablet } = useDevice();

  const { data: userFavorites, isLoading } = useGetUserFavorites(token);

  const settings = {
    dots: false,
    infinite: true,
    speed: 500,
    slidesToShow: isMobile ? 2 : isTablet ? 4 : 8,
    slidesToScroll: 1,
    nextArrow: <NextArrow />,
    prevArrow: <PrevArrow />,
  };
  return (
    <section className="UserLibrary">
      <Slider {...settings}>
        {isLoading
          ? Array.from({ length: 8 }).map((_, index) => (
              <CardSkeleton
                key={index}
                width={"95%"}
                height={isTablet ? "312px" : "230px"}
              />
            ))
          : userFavorites?.map((product) => {
              return (
                <Link
                  to={`/product/${product.slug.toLowerCase()}`}
                  className={`product ${product.slug}`}
                  key={product.slug}
                >
                  <img src={product.images[0].src} alt={product.name} />
                  <p className="product-card-name">{product.name}</p>
                </Link>
              );
            })}
      </Slider>
    </section>
  );
}

export default UserFavorites;
